import React, { useRef, useEffect, useState } from 'react';

const ProductListAccordion = ({ isOpen, children }) => {
    const contentRef = useRef(null);
    const [height, setHeight] = useState('0px');

    useEffect(() => {
        const node = contentRef.current;

        const updateHeight = () => {
            if (isOpen && node) {
                setHeight(`${node.scrollHeight}px`);
            } else {
                setHeight('0px');
            }
        };

        updateHeight(); // Initial run on mount or toggle

        if (!node) return;

        const resizeObserver = new ResizeObserver(updateHeight);
        resizeObserver.observe(node);

        return () => {
            resizeObserver.disconnect();
        };
    }, [isOpen]);

    return (
        <div className='product-list-accordion'>
            <div
                className='accordion-content-wrapper'
                style={{
                    height,
                    overflow: 'hidden',
                    transition: 'height 0.3s ease',
                }}
            >
                <div ref={contentRef} className='product-list'>
                    {children}
                </div>
            </div>
        </div>
    );
};

export default ProductListAccordion;
